const extractExperiments = (payload) => payload?.properties?.experiments

export { extractExperiments }
